<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Brandings</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="content">
    <ion-list>
      <ion-item-sliding v-for="u in brandings" :key="u.nombre">
        <ion-item v-on:click="ver(u._id)">
          <ion-thumbnail slot="start">
            <ion-img :src="cdn+u.imagen"></ion-img>
          </ion-thumbnail>
          <ion-label text-wrap>
            <h2>{{u.nombre}}</h2>
            <p>{{u.razonSocial}}</p>
          </ion-label>
          <ion-note slot="end" color="light" v-if="u.plantilladocx">
            <i class="icon ion-ios-document"></i>
          </ion-note>
        </ion-item>
        <ion-item-options slot="end">
          <ion-item-option>
            <i class="icon ion-ios-trash"></i>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </ion-list>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="ver('0')">
        <i class="icon icon-lg ion-ios-add"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'CatalogoBrandings',
  data() {
    return {
      cdn: Api.cdn + '/',
      brandings: []
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    ver(id) {
      console.log("Ver", id)
      this.$router.push('/catalogos/brandings/' + id)
    },
    async obtener() {
      this.brandings = (await Api.get('branding'))
        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
      console.log("brandings", this.brandings)
      if (false)
        for (let b of this.brandings)
          if (b.plantilladocx) {
            b.plantilladocx = null
            await Api.save('branding', b)
          }
    }
  },
  mounted() {
    this.obtener()
  }
}
</script>
